const routes = require('../../js/fos_js_routes.json');
import Routing from './SFRouter';
import Cookies from 'js-cookie';

export default class {

    static getBaseUrl() {
        return process.env.VUE_APP_API;
    }

    static getAuthHeader() {

        let cookie = Cookies.get('apiKey');

        if(cookie) {
            return {
                headers: {
                    'X-AUTH-TOKEN': cookie
                }
            };
        }
        else {
            location.reload();
        }
    }

    static logout() {
        Cookies.remove('apiKey');
        location.reload();
    }

    static handleWrongRequest(response) {
        this.logout();
    }

    static generate(routeName, parameters = {}, absolute = false) {
        Routing.setRoutingData(routes);
        return this.getBaseUrl() + Routing.generate(routeName, parameters, absolute);
    }
}